import { CheckCircle2 } from "lucide-react";

export default function About() {
  const points = [
    "Technology, FEED & EPC",
    "PMC and BOOT delivery",
    "E&P and O&M services",
    "Manufacturing partnerships",
  ];

  return (
    <section id="about" data-testid="about-section" className="py-20 lg:py-28 bg-secondary/40">
      <div className="container-wide grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative rounded-2xl overflow-hidden border border-border">
            <img
              src="https://images.unsplash.com/photo-1509391366360-2e959784a276?auto=format&fit=crop&w=1200&q=80"
              alt="Earth and sustainability"
              className="w-full h-[420px] object-cover"
              data-testid="about-image"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-primary/50 via-primary/10 to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 bg-white/95 backdrop-blur rounded-xl p-5">
              <p className="font-display text-2xl font-bold text-primary leading-tight">
                25+ Years
              </p>
              <p className="text-sm text-muted-foreground">
                of energy industry experience driving the transition to a carbon‑neutral economy.
              </p>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-primary">
            About Us
          </p>
          <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-foreground">
            Creating a sustainable world for the future
          </h2>
          <p className="mt-6 text-base lg:text-lg text-muted-foreground leading-relaxed">
            Green Earth contributes to the development of sustainable green energy
            projects and the transition from conventional to carbon‑neutral processes
            to achieve net carbon zero targets.
          </p>
          <p className="mt-4 text-base lg:text-lg text-muted-foreground leading-relaxed">
            We cater to projects and companies offering services across the full
            project lifecycle:
          </p>

          <ul className="mt-6 grid sm:grid-cols-2 gap-3">
            {points.map((p) => (
              <li
                key={p}
                data-testid={`about-point-${p.toLowerCase().replace(/\s+/g, "-")}`}
                className="flex items-start gap-3 text-sm lg:text-base text-foreground"
              >
                <CheckCircle2 className="h-5 w-5 text-primary mt-0.5 shrink-0" />
                <span>{p}</span>
              </li>
            ))}
          </ul>

          <div className="mt-8 inline-flex items-center gap-3 px-5 py-3 rounded-full bg-primary/5 border border-primary/15">
            <span className="h-2 w-2 rounded-full bg-accent animate-pulse" />
            <span className="text-sm font-medium text-primary">
              Mission: Net Carbon Zero • One‑Stop Solutions Provider
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
